import {type Line, type Point} from '../../util/plotHelpers/types';
import {type makeClampPoint} from './clampPoint';

function clampPoints(
  points: Point[],
  clampPoint: ReturnType<typeof makeClampPoint>
): Point[] {
  let clamped: Point[] | undefined;
  for (let i = 0; i < points.length; i++) {
    const point = clampPoint(points[i]);
    if (point !== points[i]) {
      clamped ??= points.slice();
      clamped[i] = point;
    }
  }
  return clamped ?? points;
}

// Keep the crosshair's source data immutable, copying only changed arrays and lines.
export function clampLinePlotLines<T extends Pick<Line, 'data' | 'nanPoints'>>(
  lines: T[],
  clampPoint: ReturnType<typeof makeClampPoint>
): T[] {
  let clamped: T[] | undefined;
  for (let i = 0; i < lines.length; i++) {
    const line = lines[i];
    const data = clampPoints(line.data, clampPoint);
    // Leave an omitted nanPoints field omitted. Aggregate band lines never set
    // it, and a fresh [] here would copy every band line on every pass.
    const nanPoints = line.nanPoints && clampPoints(line.nanPoints, clampPoint);
    if (data !== line.data || nanPoints !== line.nanPoints) {
      clamped ??= lines.slice();
      clamped[i] = nanPoints ? {...line, data, nanPoints} : {...line, data};
    }
  }
  return clamped ?? lines;
}
